import { default as FNS, logIn } from '../api';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { TYPES_META, fetchAll } from './shownDataSlice';
import { toast } from 'react-toastify';




export const fetch = createAsyncThunk('knownData/fetch', async ({ id }, { dispatch }) => {
  try {
      
    const res = await FNS.getFullQuery(id);
    dispatch(knownDataSlice.actions.addKnowns({ values: res, type: 'queries' }));
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const fetchDriverQuery = createAsyncThunk('knownData/fetchDriverQuery', async ({ secret, id, driver }, { dispatch }) => {
  try {

    const res = await FNS.getFullDriverQuery(secret, id, driver);
    dispatch(knownDataSlice.actions.addKnowns({ values: res, type: 'queries' }));
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const ensureKnown = createAsyncThunk('knownData/ensureKnown', async ({ id }, { dispatch, getState }) => {
  try {
    const state = getState();

    if(id in state.knownData) return;
    
    const res = await FNS.getFullQuery(id);
    dispatch(knownDataSlice.actions.addKnowns({ values: res, type: 'queries' }));
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const answerQuery = createAsyncThunk('knownData/answerQuery', async ({ id, tax, logisticsNotes, price }, { dispatch }) => {
  try {
    
    const res = await FNS.answerQuery(id, tax, logisticsNotes, price);
    await dispatch(fetch({ id }));
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const answerQueryAgain = createAsyncThunk('knownData/answerQueryAgain', async ({ id, tax, logisticsNotes, price }, { dispatch }) => {
  try {
    
    const res = await FNS.answerQueryAgain(id, tax, logisticsNotes, price);
    await dispatch(fetch({ id }));
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const startJob = createAsyncThunk('knownData/startJob', async ({ id, driver, bus, extraDrivers, extraBuses }, { dispatch }) => {
  try {

    const res = await FNS.startJob(id, driver, bus, JSON.stringify(extraDrivers), JSON.stringify(extraBuses));
    await dispatch(fetch({ id }));
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const updateJob = createAsyncThunk('knownData/updateJob', async ({ id, driver, bus, extraDrivers, extraBuses }, { dispatch }) => {
  try {

    const res = await FNS.updateJob(id, driver, bus, JSON.stringify(extraDrivers), JSON.stringify(extraBuses));
    await dispatch(fetch({ id }));
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const sendJobEmails = createAsyncThunk('knownData/sendJobEmails', async ({ id, driverEmailTitle, clientEmailTitle }, { dispatch }) => {
  try {

    const res = await FNS.sendJobEmails(id, driverEmailTitle, clientEmailTitle);
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const submitFeedback = createAsyncThunk('knownData/submitFeedback', async ({ id, driverId, wentWell, comment, hours, __skipFetch = false }, { dispatch }) => {
  try {

    const res = await FNS.submitFeedback(id, driverId, wentWell, comment, hours);
    if(!__skipFetch) await dispatch(fetch({id}));
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const submitDriverFeedback = createAsyncThunk('knownData/submitDriverFeedback', async ({ id, wentWell, comment, hours, driverID, secret, driver, __skipFetch = false }, { dispatch }) => {
  try {

    const res = await FNS.submitDriverFeedback(id, wentWell, comment, hours, driverID, secret, driver);
    if(!__skipFetch) await dispatch(fetch({id}));
    toast.success("Tagasiside edastatud!");
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const getJobDrivers = createAsyncThunk('knownData/getJobDrivers', async ({ id, secret, driver }, { dispatch }) => {
  try {

    const res = await FNS.getJobDrivers(id, secret, driver);
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const markFeedbackRead = createAsyncThunk('knownData/markFeedbackRead', async ({ id }, { dispatch }) => {
  try {

    const res = await FNS.markFeedbackRead(id);
    await dispatch(fetch({id}));
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const markAllJobFeedbacksRead = createAsyncThunk('knownData/markAllJobFeedbacksRead', async ({ id }, { dispatch }) => {
  try {

    const res = await FNS.markAllJobFeedbacksRead(id);
    await dispatch(fetch({id}));
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const editDriverFeedback = createAsyncThunk('knownData/editDriverFeedback', async ({ feedbackId, wentWell, comment, hours, queryId }, { dispatch }) => {
  try {

    const res = await FNS.editDriverFeedback(feedbackId, wentWell, comment, hours);
    await dispatch(fetch({id: queryId})); // Refresh the job data
    toast.success("Tagasiside uuendatud!");
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});


export const deleteQuery = createAsyncThunk('knownData/deleteQuery', async ({ id }, { dispatch }) => {
  try {

    const res = await FNS.deleteQuery(id);
    await dispatch(fetchAll());
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const updateQuery = createAsyncThunk('knownData/updateQuery', async ({ id, passengers, notes, fullname, promo, email, phone, company, start }, { dispatch }) => {
  try {

    const res = await FNS.updateQuery(id, passengers, notes, fullname, promo, email, phone, company, start);
    await dispatch(fetchAll());
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const updateQueryRoute = createAsyncThunk('knownData/updateQueryRoute', async ({ id, waypoints, notifyByEmail }, { dispatch }) => {
  try {

    const res = await FNS.updateQueryRoute(id, waypoints, notifyByEmail);
    await dispatch(fetchAll());
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const updatePrice = createAsyncThunk('knownData/updatePrice', async ({ id, tax, logisticsNotes, price }, { dispatch }) => {
  try {

    const res = await FNS.updatePrice(id, tax, logisticsNotes, price);
    await dispatch(fetch({id}));
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const updateDriverNotes = createAsyncThunk('knownData/updateDriverNotes', async ({ id, driver_notes }, { dispatch }) => {
  try {

    const res = await FNS.updateDriverNotes(id, driver_notes);
    await dispatch(fetch({ id }));
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const updateClientNotes = createAsyncThunk('knownData/updateClientNotes', async ({ id, notes }, { dispatch }) => {
  try {

    const res = await FNS.updateClientNotes(id, notes);
    await dispatch(fetch({ id }));
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const updateLogisticsNotes = createAsyncThunk('knownData/updateLogisticsNotes', async ({ id, logistics_notes }, { dispatch }) => {
  try {

    const res = await FNS.updateLogisticsNotes(id, logistics_notes);
    await dispatch(fetch({ id }));
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const updateAllNotes = createAsyncThunk('knownData/updateAllNotes', async ({ id, client_notes, logistics_notes, driver_notes }, { dispatch }) => {
  try {

    const res = await FNS.updateAllNotes(id, client_notes, logistics_notes, driver_notes);
    await dispatch(fetch({ id }));
    return res;

  } catch (e) {
    toast.error(e.message);
  }
});

export const updateQueryFoodPackages = createAsyncThunk('knownData/updateQueryFoodPackages', async ({ id, foodPackages }, { dispatch }) => {
  try {

    const res = await FNS.updateQueryFoodPackages(id, foodPackages);
    await dispatch(fetch({ id }));
    return res;
  } catch (e) {
    toast.error(e.message);
  }
});


const knownDataSlice = createSlice({
  name: 'knownData',
  initialState: {},
  reducers: {
    addKnowns: (state, { payload: { values, type } }) => {
      for(const query of values) {
        state[query[TYPES_META[type].id_field]] = {
          ...query,
          "driver_confirmations": query["driver_confirmations"] ? JSON.parse(query["driver_confirmations"]) : [],
          "extra_driver_ids": query["extra_driver_ids"] ? JSON.parse(query["extra_driver_ids"]) : [],
          "extra_driver_emails": query["extra_driver_emails"] ? JSON.parse(query["extra_driver_emails"]) : [],
          "extra_driver_names": query["extra_driver_names"] ? JSON.parse(query["extra_driver_names"]) : [],
          "extra_driver_usernames": query["extra_driver_usernames"] ? JSON.parse(query["extra_driver_usernames"]) : [],
          "extra_bus_names": query["extra_bus_names"] ? JSON.parse(query["extra_bus_names"]) : [],
        };

        console.log("new query:", state[query[TYPES_META[type].id_field]]);
      }
    },
  },
});

export const { addKnowns } = knownDataSlice.actions;
export default knownDataSlice.reducer;
